import React from 'react';
import { Megaphone, BarChart3, Video, PenTool } from 'lucide-react';
import { motion } from 'framer-motion';
const services = [{
  title: 'Strategic Communications',
  description: 'Crafting compelling narratives and brand strategies that resonate with your target audience and build lasting reputation.',
  icon: PenTool
}, {
  title: 'Media Relations & PR',
  description: 'Building strong relationships with media outlets to ensure your brand gets the visibility and credibility it deserves.',
  icon: Megaphone
}, {
  title: 'Performance Marketing',
  description: 'Data-driven digital growth strategies designed to convert interest into action and maximize your ROI.',
  icon: BarChart3
}, {
  title: 'Event & Media Production',
  description: 'End-to-end management of high-impact events and professional media production that brings your brand to life.',
  icon: Video
}];
export function ServicesSection() {
  return <section id="services" className="py-24 bg-white relative overflow-hidden scroll-mt-24" data-id="element-127">
      {/* Decorative Background */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-[#F9F9F9] -z-10 skew-x-12" data-id="element-128" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-129">
        <div className="text-center mb-20" data-id="element-130">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-131">
            <h2 className="text-[#D4AF37] font-sans font-semibold tracking-[0.2em] uppercase text-sm mb-4" data-id="element-132">
              Our Expertise
            </h2>
            <h3 className="text-4xl md:text-5xl font-serif font-medium text-[#1B4D3E] mb-6" data-id="element-133">
              Comprehensive Digital Solutions
            </h3>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto font-light" data-id="element-134">
              We offer a full suite of services to help your brand grow, engage,
              and succeed in the digital landscape.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-135">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-white p-8 border border-gray-100 hover:border-[#D4AF37]/30 shadow-sm hover:shadow-2xl transition-all duration-500 group relative overflow-hidden" data-id="element-136">
              {/* Hover Background */}
              <div className="absolute inset-0 bg-[#1B4D3E] translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-in-out z-0" data-id="element-137" />

              <div className="relative z-10" data-id="element-138">
                <div className="w-14 h-14 bg-[#1B4D3E]/5 rounded-none flex items-center justify-center mb-8 group-hover:bg-white/10 transition-colors duration-500" data-id="element-139">
                  <service.icon className="h-7 w-7 text-[#1B4D3E] group-hover:text-[#D4AF37] transition-colors duration-500" data-id="element-140" />
                </div>
                <h4 className="text-xl font-serif font-bold text-[#1B4D3E] mb-4 group-hover:text-white transition-colors duration-500" data-id="element-141">
                  {service.title}
                </h4>
                <p className="text-gray-600 leading-relaxed text-sm font-light group-hover:text-gray-300 transition-colors duration-500" data-id="element-142">
                  {service.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}